import { render, staticRenderFns } from "./i4pro-file-upload-list.vue?vue&type=template&id=bd9fd24a&scoped=true"
import script from "./i4pro-file-upload-list.vue?vue&type=script&lang=js"
export * from "./i4pro-file-upload-list.vue?vue&type=script&lang=js"
import style0 from "./i4pro-file-upload-list.vue?vue&type=style&index=0&id=bd9fd24a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd9fd24a",
  null
  
)

export default component.exports